import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IMarker } from '@obvious.tech/constellation'

export const Marker = defineEntity('Marker', {
  endpoint: 'geolocation/api/Marker',
  schema: SNoop<IMarker>(),
})
